/* RS system page: the device strip turns 3D on tap (sections/os-rs-system.liquid).
   The strip loads with still renders of the models (rss-r-*.webp). Tapping the strip or its
   3D pill loads three.js (os-rsx-three.js), the models (os-rss-glb.js, os-rsx-glb-*.js) and
   os-rsx-3d.js, then swaps each still for a canvas framed exactly like it. Drag a device to turn it.
   One WebGL renderer draws every device and copies it into that device's own 2D canvas, so
   os-rss.js keeps placing, sizing and fading the devices as before. */
(function () {
  var ORDER = ['omni', 'ti', 'rs', 'moment'];
  /* stage box of each device in os-rss.js (DEV): the still and the live frame keep this aspect */
  var ASPECT = { omni: 106.1 / 175, ti: 186 / 147, rs: 164 / 139, moment: 131 / 230 };
  /* camera angle per device (radians), matched to the photographs this strip used before */
  var HOME = { omni: { yaw: 0.75, pitch: 0.4 }, ti: { yaw: 0.35, pitch: 0.58 }, rs: { yaw: 0.82, pitch: 0.78 }, moment: { yaw: -0.4, pitch: 0.12 } };
  /* room around the frame for a device turned away from its home angle (fractions of its box) */
  var PAD = { x: 0.3, top: 0.22, bottom: 0.08 };
  var FOV = 18;
  var LIFT = { omni: { env: 2.2, color: 1.6 }, ti: { env: 2.6, color: 2.0 }, rs: { env: 1.25, color: 1.0 }, moment: { env: 1.6, color: 1.3 } };

  var THREE, R3, renderer, scene, cam, ready = {}, dev = {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup() {
    THREE = window.RSX3; R3 = window.RS3D;
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: false });
    renderer.setPixelRatio(1);
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.5;
    renderer.setClearColor(0x000000, 0);
    renderer.setScissorTest(true);
    scene = new THREE.Scene();
    var pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
    var key = new THREE.DirectionalLight(0xffffff, 1.6); key.position.set(-0.4, 0.8, 0.6); scene.add(key);
    var rim = new THREE.DirectionalLight(0xffffff, 0.8); rim.position.set(0.6, 0.4, -0.5); scene.add(rim);
    scene.add(new THREE.HemisphereLight(0xffffff, 0x8a8f94, 0.5));
    cam = new THREE.PerspectiveCamera(FOV, 1, 0.01, 10);
  }

  /* builds one device on its own turntable; resolves once its model is in */
  function build(id) {
    if (ready[id]) return ready[id];
    var m = R3.MAKE[id](), piv = new THREE.Group();
    m.g.traverse(function (o) { if (o.userData && o.userData.contact) o.visible = false; });
    var lift = function () {
      /* the strip sits on light grey: lift the near-black finishes so they read like the photographs */
      var seenM = [];
      m.g.traverse(function (o) {
        var mt = o.material; if (!o.isMesh || !mt || !mt.isMeshStandardMaterial || seenM.indexOf(mt) > -1) return;
        seenM.push(mt); mt.envMapIntensity = (mt.envMapIntensity || 1) * LIFT[id].env; mt.color.multiplyScalar(LIFT[id].color);
      });
    };
    piv.add(m.g); piv.visible = false; scene.add(piv);
    dev[id] = { piv: piv, g: m.g, yaw: 0, goal: 0 };
    ready[id] = m.ready.then(function () {
      lift();
      /* turn about the middle of the footprint */
      piv.updateMatrixWorld(true);
      var bb = new THREE.Box3().setFromObject(m.g);
      var c = bb.getCenter(new THREE.Vector3());
      m.g.position.x -= c.x; m.g.position.z -= c.z;
      dev[id].h = bb.max.y; dev[id].r = Math.hypot(bb.max.x - bb.min.x, bb.max.z - bb.min.z) / 2;
      frameOf(id);
    });
    return ready[id];
  }

  /* points on the model, for a tight frame */
  function samples(id) {
    var d = dev[id], pts = [], v = new THREE.Vector3();
    d.piv.updateMatrixWorld(true);
    d.g.traverse(function (o) {
      if (!o.isMesh || !o.visible || !o.geometry || !o.geometry.attributes.position) return;
      var p = o.geometry.attributes.position, step = Math.max(1, Math.floor(p.count / 6000));
      for (var i = 0; i < p.count; i += step) { v.fromBufferAttribute(p, i).applyMatrix4(o.matrixWorld); pts.push(v.clone()); }
    });
    return pts;
  }

  /* camera at the home angle, and the part of a square image the device's box covers */
  function aim(id) {
    var h = HOME[id], d = dev[id], t = new THREE.Vector3(0, d.h * 0.45, 0), D = 1.2;
    cam.aspect = 1; cam.clearViewOffset();
    cam.position.set(t.x + D * Math.cos(h.pitch) * Math.sin(h.yaw), t.y + D * Math.sin(h.pitch), t.z + D * Math.cos(h.pitch) * Math.cos(h.yaw));
    cam.lookAt(t); cam.updateProjectionMatrix(); cam.updateMatrixWorld(true);
  }
  function frameOf(id) {
    var d = dev[id], S = 4000;
    var rot = d.piv.rotation.y; d.piv.rotation.y = 0;
    aim(id);
    var x0 = 1e9, x1 = -1e9, y0 = 1e9, y1 = -1e9;
    samples(id).forEach(function (p) { p.project(cam); x0 = Math.min(x0, p.x); x1 = Math.max(x1, p.x); y0 = Math.min(y0, p.y); y1 = Math.max(y1, p.y); });
    d.piv.rotation.y = rot;
    var X0 = (x0 + 1) / 2 * S, X1 = (x1 + 1) / 2 * S, T = (1 - y1) / 2 * S, B = (1 - y0) / 2 * S;
    var w = X1 - X0, hh = B - T, a = ASPECT[id], W, H, x, y;
    if (w / hh < a) { W = hh * a; H = hh; x = X0 - (W - w) / 2; y = T; }
    else { W = w; H = w / a; x = X0; y = B - H; }
    d.box = { S: S, x: x, y: y, w: W, h: H };
  }

  /* renders device id into a w x h region of the shared buffer; pad = include the room around the box */
  var bufW = 0, bufH = 0;
  function draw(id, w, h, pad) {
    var d = dev[id], b = d.box;
    if (w > bufW || h > bufH) { bufW = Math.max(bufW, w); bufH = Math.max(bufH, h); renderer.setSize(bufW, bufH, false); }
    ORDER.forEach(function (k) { if (dev[k]) dev[k].piv.visible = k === id; });
    aim(id);
    var px = pad ? PAD.x * b.w : 0, pt = pad ? PAD.top * b.h : 0, pb = pad ? PAD.bottom * b.h : 0;
    cam.setViewOffset(b.S, b.S, b.x - px, b.y - pt, b.w + 2 * px, b.h + pt + pb);
    renderer.setViewport(0, 0, w, h); renderer.setScissor(0, 0, w, h);
    renderer.clear(); renderer.render(scene, cam);
    return { src: renderer.domElement, sy: bufH - h };
  }

  /* still image of one device, h pixels tall (for making rss-r-*.webp) */
  function still(id, h) {
    var w = Math.round(h * ASPECT[id]), r = draw(id, w, h, false);
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    c.getContext('2d').drawImage(r.src, 0, r.sy, w, h, 0, 0, w, h);
    return c;
  }

  function load(src) {
    return new Promise(function (ok, no) { var s = document.createElement('script'); s.src = src; s.async = false; s.onload = ok; s.onerror = no; document.head.appendChild(s); });
  }
  function boot(A) {
    var chain = Promise.resolve();
    window.__RSX_A = window.__RSX_A || { scr_ready: A.scr_ready, scr_pill: A.scr_pill };
    if (!window.RSX3) chain = chain.then(function () { return load(A.x3); });
    if (!window.__RSS_GLB) chain = chain.then(function () { return load(A.glb); });
    ['ti', 'omni', 'moment'].forEach(function (k) {
      chain = chain.then(function () { if (!(window.__RSX_GLB && window.__RSX_GLB[k])) return load(A['glb_' + k]); });
    });
    return chain.then(function () { if (!window.RS3D || !window.RS3D.MAKE) return load(A.rsx3d); });
  }

  /* ---------- the strip ---------- */
  function strip(frame, A, copy) {
    var devEls = frame.querySelectorAll('.rss-dev'); if (devEls.length !== 4) return;
    var css = document.createElement('style');
    css.textContent =
      '.rss .rss-dev canvas.rss-live{position:absolute;left:' + (-PAD.x * 100) + '%;width:' + (100 + 2 * PAD.x * 100) + '%;top:' + (-PAD.top * 100) + '%;height:' + (100 + (PAD.top + PAD.bottom) * 100) + '%;z-index:2;touch-action:pan-y;cursor:grab;opacity:0;transition:opacity .4s ease}' +
      '.rss .rss-dev canvas.rss-live:active{cursor:grabbing}' +
      '.rss .rss-stage-frame.rss-is-live .rss-dev canvas.rss-live{opacity:1}' +
      '.rss .rss-stage-frame.rss-is-live .rss-dev img{opacity:0;transition:opacity .4s ease}' +
      '.rss .rss-stage-frame.rss-is-live .rss-dev.rss-gone canvas.rss-live{pointer-events:none}' +
      '.rss .rss-stage-frame{cursor:pointer}.rss .rss-stage-frame.rss-is-live{cursor:default}' +
      '.rss .rss-3dpill{position:absolute;right:12px;bottom:12px;z-index:3;display:inline-flex;align-items:center;gap:6px;height:32px;padding:0 12px;border:0;border-radius:999px;background:rgba(10,13,16,.78);color:#e8eaed;font:600 13px/1 var(--df-font,inherit);letter-spacing:.02em;cursor:pointer;transition:opacity .3s ease}' +
      '.rss .rss-3dpill svg{width:15px;height:15px}' +
      '.rss .rss-3dpill.rss-busy svg{animation:rss-3dspin 1s linear infinite}' +
      '@keyframes rss-3dspin{to{transform:rotate(360deg)}}' +
      '.rss .rss-3dpill.rss-hint{cursor:default;pointer-events:none}' +
      '.rss .rss-3dpill.rss-off{opacity:0;pointer-events:none}';
    document.head.appendChild(css);

    var pill = document.createElement('button');
    pill.type = 'button'; pill.className = 'rss-3dpill';
    pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/></svg><span></span>';
    pill.querySelector('span').textContent = copy['live.3d'] || '3D';
    frame.appendChild(pill);

    var state = 'still', live = {};
    function start(e) {
      if (state !== 'still') return;
      if (e && e.target.closest && e.target.closest('a,input,select')) return;
      state = 'loading'; pill.classList.add('rss-busy');
      boot(A).then(function () {
        setup();
        return Promise.all(ORDER.map(build));
      }).then(function () {
        ORDER.forEach(function (id, i) { mountDev(id, devEls[i]); });
        state = 'live'; frame.classList.add('rss-is-live');
        pill.classList.remove('rss-busy'); pill.classList.add('rss-hint');
        pill.querySelector('span').textContent = copy['live.drag'] || '';
        setTimeout(function () { pill.classList.add('rss-off'); }, 4000);
        if (!reduce) ORDER.forEach(function (id, i) { greet(id, i); });
        paint();
      }).catch(function () { state = 'failed'; pill.classList.add('rss-off'); frame.style.cursor = ''; });
    }
    frame.addEventListener('click', start);

    function mountDev(id, el) {
      var c = document.createElement('canvas'); c.className = 'rss-live'; c.setAttribute('aria-hidden', 'true');
      el.appendChild(c);
      var L = live[id] = { el: el, c: c, ctx: c.getContext('2d'), w: 0, h: 0, dirty: true };
      var drag = null;
      c.addEventListener('pointerdown', function (e) {
        drag = { x: e.clientX, yaw: dev[id].goal, touch: e.pointerType === 'touch' };
        if (!drag.touch) { try { c.setPointerCapture(e.pointerId); } catch (er) {} }
        dev[id].held = true; kick();
      });
      c.addEventListener('pointermove', function (e) {
        if (!drag) return;
        dev[id].goal = drag.yaw + (e.clientX - drag.x) * 0.012; kick();
      });
      function end() { drag = null; dev[id].held = false; }
      c.addEventListener('pointerup', end); c.addEventListener('pointercancel', end);
      return L;
    }

    /* each device turns once, a little, when the strip goes live */
    function greet(id, i) {
      var t0 = performance.now() + i * 140, d = dev[id];
      d.greet = function (now) {
        var t = (now - t0) / 1400; if (t < 0) return true; if (t >= 1) { d.goal = 0; return false; }
        d.goal = Math.sin(t * Math.PI * 2) * 0.45 * (1 - t); return true;
      };
    }

    var raf = null, seen = true;
    function kick() { if (!raf && seen) raf = requestAnimationFrame(tick); }
    function tick(now) {
      raf = null;
      var more = false, dpr = Math.min(2, window.devicePixelRatio || 1);
      ORDER.forEach(function (id) {
        var d = dev[id], L = live[id]; if (!L) return;
        if (d.greet && !d.held) { if (d.greet(now)) more = true; else d.greet = null; }
        var k = reduce ? 1 : 0.22, diff = d.goal - d.yaw;
        if (Math.abs(diff) > 1e-4) { d.yaw += diff * k; more = true; L.dirty = true; } else if (d.yaw !== d.goal) { d.yaw = d.goal; L.dirty = true; }
        var w = Math.round(L.c.clientWidth * dpr), h = Math.round(L.c.clientHeight * dpr);
        if (w !== L.w || h !== L.h) { L.w = L.c.width = w; L.h = L.c.height = h; L.dirty = true; }
        if (!L.dirty || !w || !h || L.el.classList.contains('rss-gone') && !d.held) return;
        d.piv.rotation.y = d.yaw;
        var r = draw(id, w, h, true);
        L.ctx.clearRect(0, 0, w, h); L.ctx.drawImage(r.src, 0, r.sy, w, h, 0, 0, w, h);
        L.dirty = false;
      });
      if (more || held()) kick();
    }
    function held() { return ORDER.some(function (id) { return dev[id] && dev[id].held; }); }
    function paint() { ORDER.forEach(function (id) { if (live[id]) live[id].dirty = true; }); kick(); }
    /* the devices change size when units are added or removed: redraw while that runs */
    var ro = new ResizeObserver(function () { if (state === 'live') paint(); });
    devEls.forEach(function (el) { ro.observe(el); });
    frame.addEventListener('transitionend', function () { if (state === 'live') paint(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { seen = es.some(function (e) { return e.isIntersecting; }); if (seen && state === 'live') paint(); }).observe(frame);
  }

  window.RSSLive = { LIFT: LIFT, still: still, setup: function () { setup(); }, build: function (id) { return build(id); }, boot: boot, HOME: HOME, frameOf: function (id) { frameOf(id); } };

  function init() {
    var root = document.querySelector('.rss'), frame = root && root.querySelector('#frame');
    if (!frame) return;
    var A = JSON.parse(root.querySelector('[data-rss-assets]').textContent);
    var copy = JSON.parse(root.querySelector('[data-rss-copy]').textContent);
    /* os-rss.js fills the stage first */
    var tries = 0;
    (function wait() { if (frame.querySelectorAll('.rss-dev').length === 4) strip(frame, A, copy); else if (tries++ < 100) setTimeout(wait, 50); })();
  }
  if (document.querySelector('[data-rss-assets]')) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init(); }
})();
